import { useStore } from "vuex";
import { useCategoriesStore } from "@/stores/categories/index.ts";

export default function useCMSData() {
  const store = useStore();
  const categoriesStore = useCategoriesStore();

  async function loadCMSData(to) {
    const opts = { isCms: false };
    if (["Categories", "Category", "SubCategories"].includes(to.name)) {
      await store.dispatch("api/fetchMoveDocumentDestinations", {
        documentType: "category",
        opts,
      });
    }

    if (["Person", "Category"].includes(to.name)) {
      await store.dispatch("api/fetchMoveDocumentDestinations", {
        documentType: "entry",
        opts,
      });
    }

    if (to.name === "PostRedirect") {
      return;
    }

    // We need to load categories data for two reasons:
    // 1. because it's needed for CMS page settings etc.
    // 2. because non-admin user may not have access
    // to all categories so these are intentionally
    // removed by the /getDocuments endpoint.
    await categoriesStore.fetch();
    await store.dispatch("api/fetchAllCategories");
  }

  return {
    loadCMSData,
  };
}
